import { https } from "../http";
import store from "../store";
import {
  setAllProcCode,
  setAllServiceCode,
  setLoading,
  setAllDiagnosisCode,
  setAllProviderServices,
} from "../store/reducers/servicecode";

import { showError } from "../utils/index";

const getServicecode = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get("servicecode/all");

    if (response?.status === 200) {
      store.dispatch(setAllServiceCode(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getProccode = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get("servicecode/allproccode");

    if (response?.status === 200) {
      store.dispatch(setAllProcCode(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getProviderServices = async (name, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(
      `servicecode/allproviderservices${name ? `?name=${name}` : ''}`,
    );

    if (response?.status === 200) {
      store.dispatch(setAllProviderServices(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getdiagnosiscode = async (name,showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`diagnosiscode/alldiagnosiscode${name ? `?name=${name}` : ''}`);

    if (response?.status === 200) {
      store.dispatch(setAllDiagnosisCode(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export { getServicecode, getProccode, getdiagnosiscode, getProviderServices };
